<template>
  <div class="exceptionPage">
    <div class="imgEle"></div>
    <div class="exceptionTip">
      <h1 class="exceptionText">403</h1>
      <div class="exceptionDesc">抱歉，你无权访问该页面</div>
      <Button type="primary" @click="goBack">返回首页</Button>
    </div>
  </div>
</template>
<script>
import { Button } from 'ant-design-vue'
import { getSession } from '../../libs/utils'
import { isArray } from 'lodash'
export default {
  components: {
    Button
  },
  methods: {
    async goBack () {
      let userAuth = getSession('userAuth', 'object')
      const menus = userAuth && userAuth.authMenus
      if (!isArray(menus) || menus.length < 1) {
        sessionStorage.clear()
        return this.$router.replace({ name: 'login' })
      }
      return this.$router.replace({ path: `/${menus[0]['resources']}`})
    }
  }
}
</script>
<style lang="less">
@import url('../../style/index.less');
.exceptionPage{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .imgEle{
    width: 430px;
    height: 360px;
    background: url('@{bgImgDomain}/images/403.svg') no-repeat center center;
    background-size: contain;
  }
  .exceptionTip{
    .exceptionText{
      margin-bottom: 24px;
      color: #434e59;
      font-weight: 600;
      font-size: 72px;
      line-height: 72px;
    }
    .exceptionDesc{
      margin-bottom: 16px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 20px;
      line-height: 28px;
    }
  }
}
</style>